function FileIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="24"
      fill="none"
      viewBox="0 0 19 24"
    >
      <path
        fill="#fff"
        stroke="#E5E5E5"
        d="M18.054 3.878v19.283a.34.34 0 01-.34.339H2.25a.34.34 0 01-.339-.339V.84A.34.34 0 012.25.5h12.419l3.385 3.378z"
      ></path>
      <path
        fill="#E5E5E5"
        d="M18.554 3.67v19.491a.84.84 0 01-.839.839h-1.198a.84.84 0 00.84-.839V3.671L13.684 0h1.197l3.672 3.67z"
      ></path>
      <path
        fill="#CECECE"
        d="M18.554 3.67h-2.84a.84.84 0 01-.838-.838V0l3.678 3.67zM15.01 11.365H5.052a.61.61 0 01-.608-.608.61.61 0 01.608-.608h9.958a.61.61 0 01.607.608c0 .34-.267.608-.607.608zM15.01 14.483H5.052a.61.61 0 01-.608-.608.61.61 0 01.608-.607h9.958a.61.61 0 01.607.607c0 .34-.267.608-.607.608zM15.01 17.6H5.052a.61.61 0 01-.608-.608.61.61 0 01.608-.607h9.958a.61.61 0 01.607.607c0 .34-.267.608-.607.608z"
      ></path>
      <path
        fill="#F55B4B"
        d="M8.42 8.205H0v-3.41c0-.255.207-.468.468-.468H8.42c.255 0 .468.207.468.468v2.942a.468.468 0 01-.468.468z"
      ></path>
      <path
        fill="#DD4E43"
        d="M8.888 7.676v.06a.468.468 0 01-.468.469H0v-3.41c0-.255.207-.468.468-.468h.237v1.216c0 1.179.955 2.139 2.14 2.139h6.043v-.006z"
      ></path>
      <path fill="#DB1B1B" d="M0 8.205L1.41 9.81V8.205H0z"></path>
      <path
        fill="#fff"
        d="M2.28 7.002v.407H1.008v-.407h.31V5.403h-.31v-.407h1.27c.298 0 .523.067.687.207.164.14.243.328.243.559 0 .134-.03.255-.085.365a.588.588 0 01-.218.249.84.84 0 01-.304.121c-.116.025-.256.03-.426.03h-.231v.469h.334v.006zm-.335-.875h.091c.213 0 .353-.037.414-.104a.38.38 0 00.09-.261.393.393 0 00-.066-.225.289.289 0 00-.146-.115 1.306 1.306 0 00-.274-.025H1.94v.73h.006zM3.356 7.409v-.407h.365V5.403h-.365v-.407h1.143c.243 0 .431.012.583.043.146.03.286.097.42.194.134.103.243.237.322.407a1.4 1.4 0 01.036 1.045 1.143 1.143 0 01-.212.371.944.944 0 01-.304.225 1.346 1.346 0 01-.322.11c-.098.018-.25.024-.456.024h-1.21v-.006zm.997-.407h.152c.182 0 .328-.025.438-.073a.534.534 0 00.255-.25.956.956 0 00.097-.467c0-.183-.03-.34-.097-.468a.544.544 0 00-.268-.268 1.07 1.07 0 00-.425-.073h-.152v1.599zM6.225 7.409v-.407h.347V5.403h-.347v-.407H8.39v.748h-.462v-.335h-.723v.56h.523v.407h-.523v.626h.37v.407H6.226z"
      ></path>
      <path
        fill="#E5E5E5"
        d="M7.496 9.335h-6.08v-1.13H8.45v.182a.959.959 0 01-.954.948z"
      ></path>
    </svg>
  );
}

export default FileIcon;
